import CountryRedirect from '@/components/CountryRedirect'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: CountryRedirect
	}

	let page = vuewidget(dom, options)
	return page
}
